var DB_VIEW, EnsureReferenceHasAttachmentType, Migration, mediator,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Migration = require('./migration');

DB_VIEW = require('lib/references_utils').DB_VIEW;

mediator = require('mediator');

module.exports = EnsureReferenceHasAttachmentType = (function(_super) {
  __extends(EnsureReferenceHasAttachmentType, _super);

  function EnsureReferenceHasAttachmentType() {
    EnsureReferenceHasAttachmentType.__super__.constructor.call(this, false);
  }

  EnsureReferenceHasAttachmentType.prototype.up = function(project) {
    var migrationName, projectId;
    EnsureReferenceHasAttachmentType.__super__.up.apply(this, arguments);
    projectId = project.id;
    migrationName = 'ensure_reference_has_attachment_type';
    return mediator.services.storePersistenceAdapter.fetchWithView(projectId, 'references', DB_VIEW).then(function(references) {
      var updatedDocs;
      updatedDocs = _.chain(references).filter(function(ref) {
        var attachment;
        attachment = ref.attachment;
        return (attachment != null) && (attachment.type == null) && (attachment.id != null) && (attachment.fileName != null);
      }).map(function(ref) {
        return _.extend({}, ref, {
          attachment: _.extend({}, ref.attachment, {
            type: 'uploaded'
          }),
          rev_author: "project_migration/" + migrationName
        });
      }).value();
      if (_.isEmpty(updatedDocs)) {
        return;
      }
      return mediator.services.storePersistenceAdapter.bulkDocs(projectId, updatedDocs);
    });
  };

  return EnsureReferenceHasAttachmentType;

})(Migration);
